module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-03.3de93074.png";